import { render } from "./DashboardBuildingCard.vue?vue&type=template&id=6562aa46"
import script from "./DashboardBuildingCard.vue?vue&type=script&lang=js"
export * from "./DashboardBuildingCard.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "6562aa46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6562aa46', script)) {
    api.reload('6562aa46', script)
  }
  
  module.hot.accept("./DashboardBuildingCard.vue?vue&type=template&id=6562aa46", () => {
    api.rerender('6562aa46', render)
  })

}

script.__file = "src/components/dashboard/DashboardBuildingCard.vue"

export default script